export default {
  errors: null,
  addresses: [],
  loading: false,
  count: 0,
  totalCount: 0
};
